import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import useDebounce from "hooks/useDebounce";
import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { Link, useNavigate, useParams } from "react-router-dom";

import { Button } from "components/Button/Button";

import useMuiButtonLoader from "hooks/useMuiButtonLoader";

import { getCenterVideoBanks, mapCenterVideo } from "services/centers";
import { Table } from "react-bootstrap";
import { getCityWiseVideoBanks, mapCityWiseVideo } from "services/citypages";

const CityWiseIntroVideoMapping = () => {
  const { cityid } = useParams();
  const navigate = useNavigate();

  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [assignModal, setAssignModal] = useState(false);

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [selectedId, setSelectedId] = useState("");

  //**********video bank Listing**********/
  const videoBankList = async (page = activePage, search = debounceValue) => {
    try {
      showLoader();
      const res = await getCityWiseVideoBanks({
        page,
        search,
        cityid: cityid,
      });
      hideLoader();
      if (res.code === 200) {
        const { video, count } = res.data;
        setRecord(video || []);
        setTotal(count || 0);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    setActivePage(event);
    videoBankList(event);
  };

  //*********Handel Search************** */
  const [search, setSearch] = useState("");
  const debounceValue = useDebounce(search, 300);

  // delete function
  const assignHandler = async () => {
    if (selectedId) {
      try {
        setSubmitLoading(true);
        const res = await mapCityWiseVideo({
          videoBankId: selectedId,
          cityid: cityid,
        });
        if (res.code === 200) {
          videoBankList();
          toast.success(res.message);
          setAssignModal(false);
          setSubmitLoading(false);
          navigate("/city-pages/city-wise-centers");
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    }
  };

  useEffect(() => {
    videoBankList(activePage, debounceValue);
    // eslint-disable-next-line
  }, [debounceValue]);

  return (
    <React.Fragment>
      <title>Shubhra Viraj | City Wise Link Center Intro Video</title>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="SearchBox">
                <div className="div_wrap">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control"
                    name="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div className="div_no_wrap mx-3"></div>
              </div>
              <h4 className="Title">
                <Link to={-1}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                City Wise Link Intro Video
              </h4>
            </div>
            <div className="TableList overflow-auto table-responsive">
              {loader}

              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Title</th>
                    <th>Duration</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        { videoTitle, videoDuration, videoId, isAssigned },
                        i
                      ) => (
                        <tr key={i}>
                          <td>{++i + (activePage - 1) * 10}</td>
                          <td>
                            <div className="">{videoTitle}</div>
                          </td>

                          <td>{videoDuration}</td>

                          <td>
                            <div className="d-flex justify-content-center">
                              {isAssigned ? (
                                <Button size="small" style={{color:"red", border: "1px solid red"}}>Assigned</Button>
                              ) : (
                                <Button
                                  size="small"
                                  onClick={() => {
                                    setSelectedId(videoId);
                                    setAssignModal(true);
                                  }}
                                >
                                  Assign
                                </Button>
                              )}
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/*assign model */}
      <ModalBox
        status={assignModal}
        onClose={() => setAssignModal(false)}
        title={"Assign Video"}
        description={"Are you sure want to assign this video ?"}
        customizedFooter={
          <Button onClick={assignHandler} {...submitButtonElement}>
            Yes
          </Button>
        }
      />
    </React.Fragment>
  );
};

export default CityWiseIntroVideoMapping;
